// 二维码包含连字符时，取最后一个连字符后面的内容。
export const normalizeQrCode = (code) => {
  return typeof code === 'string' && code.indexOf('-') !== -1
    ? code.split('-').pop()
    : code
}
